import { NeuraumEntity } from '@js/common/types/DomainTypes'

import { Nullable } from '@f-fertighaus/applications/Next/types/utility'
import { RatingValue } from '@f-fertighaus/applications/SalesAgentDashboard/hooks/useReviewsReplyFiltersAndSorting'

import { Status } from '../pages/OpportunityPage/createOpportunityForm/Types'
import { GenderType } from '../SalesAgentDashboardData'

export enum ReviewRating {
  'level-1' = 1,
  'level-2',
  'level-3',
  'level-4',
  'level-5'
}

export type ReviewStatus =
  | 'not_requested'
  | 'requested'
  | 'pending'
  | 'published_reply_pending'
  | 'published_complete'

export interface SADBReview<ReviewStatusType = ReviewStatus> {
  nid: string
  vendor: Reference
  sales_agent: Reference
  opportunity: Nullable<Reference>
  profile_public_id: Nullable<string>
  status: ReviewStatusType
  updated_at: string
  title: Nullable<string>
  text: Nullable<string>
  rating: Nullable<ReviewRating>
  building_phase: Nullable<ReviewBuildingPhase>
  vendor_reply: Nullable<string>
  vendor_reply_ai_suggestions: string[]
  replied_after: Nullable<number>
  experience_postal_code: Nullable<string>
  experience_city: Nullable<string>
  reviewer_gender: Nullable<GenderType>
  reviewer_first_name: string
  reviewer_last_name: string
  create_opportunity: boolean
  reviewer_email: Nullable<string>
  rated_at: Nullable<string>
  published_at: Nullable<string>
  contact_person: string
  opportunity_status: Nullable<Status>
  published_in: Nullable<string>
  requested_at: Nullable<string>
  source: Nullable<'organic' | 'invited'>
  consent: boolean
}

export type ReviewBuildingPhase =
  | 'open'
  | 'qualification'
  | 'offer_made'
  | 'contract_signed'
  | 'info_material_received'
  | '1st_sales_rep_call_done'
  | '1st_meeting_done'
  | 'moving_in_happened'

interface Reference extends NeuraumEntity {
  href: string
}

export interface ReviewFilters {
  building_phase__in?: ReviewBuildingPhase[]
  status__in?: ReviewStatus[]
  vendor_reply__isnull?: ('true' | 'false')[]
  rating__in?: RatingValue[]
  rated_at__date__gte?: string
  rated_at__date__lte?: string
  updated_at__date__gte?: string
  updated_at__date__lte?: string
  contact_person__in?: string[]
}
